// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2CtoL","errorLogs":"EditorFooter_errorLogs__2F5yx"};